// A TABELA DOS ENDEREÇOS LIMPOS (06/10/2026) — ver `docs/navegacao/README.md`.
//
// Cada linha liga o endereço INTERNO do roteador (o que vem depois de
// `/app/accounts/:conta/`) ao endereço que a pessoa vê na barra. As rotas do
// app não mudam: só a tradução.
//
//   exato   só o endereço inteiro (`dashboard` ↔ `conversas`)
//   ramo    o endereço e tudo abaixo dele (`processos/27/…` ↔ `processos/27/…`)
//   filhos  só o que está ABAIXO (`conversations/42` ↔ `conversas/42`), porque
//           o próprio `conversas` já é de outra linha
//
// Regras para mexer aqui:
// - nenhum endereço externo pode colidir com o Rails (`/api`, `/auth`, `/hc`,
//   `/widget`, `/webhooks`, `/correio/a`, arquivos de `public/` — lista em
//   `docs/navegacao/MAPA-SERVIDOR.md`) nem conter "/auth" ou "/login";
// - todo prefixo externo novo precisa existir também em `EXTERNOS` abaixo,
//   que o Rails usa para servir o app (config/routes.rb);
// - o spec confere ida e volta de todas as rotas.
export const REGRAS = [
  // Início e conversas
  { interno: 'processos/dashboard', externo: 'inicio', tipo: 'exato' },
  { interno: 'dashboard', externo: 'conversas', tipo: 'exato' },
  { interno: 'conversations', externo: 'conversas', tipo: 'filhos' },
  { interno: 'inbox', externo: 'conversas/caixa', tipo: 'filhos' },
  { interno: 'label', externo: 'conversas/etiqueta', tipo: 'filhos' },
  { interno: 'team', externo: 'conversas/time', tipo: 'filhos' },
  { interno: 'custom_view', externo: 'conversas/pasta', tipo: 'filhos' },
  {
    interno: 'mentions/conversations',
    externo: 'conversas/mencoes',
    tipo: 'ramo',
  },
  {
    interno: 'unattended/conversations',
    externo: 'conversas/sem-resposta',
    tipo: 'ramo',
  },
  {
    interno: 'participating/conversations',
    externo: 'conversas/participando',
    tipo: 'ramo',
  },
  { interno: 'inbox-view', externo: 'caixa-de-entrada', tipo: 'ramo' },
  { interno: 'internal-chat', externo: 'chat-interno', tipo: 'ramo' },

  // Jurídico
  { interno: 'processos', externo: 'processos', tipo: 'ramo' },
  { interno: 'clientes', externo: 'clientes', tipo: 'ramo' },
  { interno: 'casos', externo: 'casos', tipo: 'ramo' },
  { interno: 'publicacoes', externo: 'publicacoes', tipo: 'ramo' },
  { interno: 'ged', externo: 'documentos', tipo: 'ramo' },
  { interno: 'minutas', externo: 'minutas', tipo: 'ramo' },
  { interno: 'contratos', externo: 'contratos', tipo: 'ramo' },
  { interno: 'contratos-antigo', externo: 'contratos-antigo', tipo: 'ramo' },
  { interno: 'financeiro', externo: 'financeiro', tipo: 'ramo' },
  // "Dados do escritório" (Minutas) caía em `processos/configuracoes` — a tela
  // é dos dados do escritório, não de processos (Victor, 06/10/2026).
  {
    interno: 'processos/configuracoes',
    externo: 'configuracoes/escritorio',
    tipo: 'exato',
  },

  // Agenda: o calendário é a casa dela
  { interno: 'appointments/calendar', externo: 'agenda', tipo: 'exato' },
  {
    interno: 'appointments/agenda',
    externo: 'agenda/atividades',
    tipo: 'exato',
  },
  {
    interno: 'appointments/dashboard',
    externo: 'agenda/painel',
    tipo: 'exato',
  },
  {
    interno: 'appointments/office',
    externo: 'agenda/escritorio',
    tipo: 'exato',
  },
  {
    interno: 'appointments/rescheduling',
    externo: 'agenda/reagendamentos',
    tipo: 'exato',
  },
  {
    interno: 'appointments/reports',
    externo: 'agenda/relatorios',
    tipo: 'exato',
  },
  {
    interno: 'appointments/clients',
    externo: 'agenda/clientes',
    tipo: 'exato',
  },
  {
    interno: 'appointments/professionals',
    externo: 'agenda/profissionais',
    tipo: 'exato',
  },
  {
    interno: 'appointments/services',
    externo: 'agenda/servicos',
    tipo: 'exato',
  },
  {
    interno: 'appointments/partners',
    externo: 'agenda/parceiros',
    tipo: 'exato',
  },
  { interno: 'appointments', externo: 'agenda', tipo: 'ramo' },

  // Atendimento e comercial
  { interno: 'pipeline', externo: 'funil', tipo: 'ramo' },
  { interno: 'follow-ups', externo: 'follow-ups', tipo: 'ramo' },
  { interno: 'contacts', externo: 'contatos', tipo: 'ramo' },
  { interno: 'companies', externo: 'empresas', tipo: 'ramo' },
  { interno: 'correio', externo: 'email', tipo: 'ramo' },
  {
    interno: 'central-telefonica',
    externo: 'central-telefonica',
    tipo: 'ramo',
  },
  { interno: 'analise-comercial', externo: 'analise-comercial', tipo: 'ramo' },
  { interno: 'advup-labs', externo: 'labs', tipo: 'ramo' },
  { interno: 'lumos', externo: 'lumos', tipo: 'ramo' },
  { interno: 'campaigns', externo: 'campanhas', tipo: 'ramo' },
  { interno: 'broadcasts', externo: 'disparos', tipo: 'ramo' },
  { interno: 'menu-apps', externo: 'apps', tipo: 'ramo' },

  // Conta, busca, relatórios e configurações
  { interno: 'search', externo: 'busca', tipo: 'ramo' },
  { interno: 'notifications', externo: 'notificacoes', tipo: 'ramo' },
  // O que mudou no advup (22/10/2026): o megafone leva a `/novidades#retomada`.
  { interno: 'novidades', externo: 'novidades', tipo: 'ramo' },
  { interno: 'reports', externo: 'relatorios', tipo: 'ramo' },
  { interno: 'portals', externo: 'central-de-ajuda', tipo: 'ramo' },
  { interno: 'settings', externo: 'configuracoes', tipo: 'ramo' },
  { interno: 'profile', externo: 'perfil', tipo: 'ramo' },
  // A Saúde do sistema é item do menu de Configurações (06/10/2026). A linha
  // de baixo fica só para quem guardou o endereço de ontem: na ida vale a
  // primeira (mesma origem, ordem da lista); na volta, as duas.
  {
    interno: 'system-health',
    externo: 'configuracoes/saude-do-sistema',
    tipo: 'ramo',
  },
  { interno: 'system-health', externo: 'saude-do-sistema', tipo: 'ramo' },
  { interno: 'suspended', externo: 'conta-suspensa', tipo: 'exato' },
];

// AS PALAVRAS DE DENTRO DO CAMINHO (06/10/2026). A tabela acima troca o
// COMEÇO do endereço; o resto saía em inglês — `/configuracoes/inboxes/list`,
// `/funil/sequences/new` (Victor: "tudo funcionando conforme faça sentido").
// Cada palavra fixa das rotas tem a sua tradução, de mão dupla.
//
// Regras para mexer aqui:
// - mão dupla: nenhuma tradução pode repetir outra nem ser uma palavra que
//   JÁ existe em português dentro de alguma rota (`modelos` é das Minutas,
//   por isso `templates` → `modelos-de-mensagem`; `relatorios` é de
//   Processos, por isso `reports` → `relatorio`; `painel` é do Lumos, por
//   isso `dashboard` → `resumo`), nem o nome de uma aba que vai no caminho
//   das fichas (`documentos`, `dados-principais`…) — o spec de ida e volta
//   de TODAS as rotas e das abas reprova colisão;
// - nome próprio fica (linear, slack, whatsapp, sla…).
export const PALAVRAS = {
  active: 'ativos',
  agent: 'agente',
  'agent-bots': 'robos',
  agents: 'agentes',
  agents_overview: 'visao-dos-agentes',
  analytics: 'analise',
  appointments: 'agenda',
  articles: 'artigos',
  assignment: 'atribuicao',
  'assignment-policy': 'politicas-de-atribuicao',
  assistants: 'assistentes',
  'audit-logs': 'auditoria',
  automation: 'automacao',
  automations: 'automacoes',
  billing: 'plano',
  blacklist: 'bloqueados',
  bot: 'robo',
  cadences: 'cadencias',
  calendar: 'calendario',
  'canned-response': 'respostas-prontas',
  capacity: 'capacidade',
  categories: 'categorias',
  clients: 'clientes',
  conversation: 'conversa',
  'conversation-workflow': 'fluxo-de-atendimento',
  conversations: 'conversas',
  create: 'criar',
  'custom-attributes': 'atributos',
  'custom-roles': 'papeis',
  dashboard: 'resumo',
  dashboard_apps: 'apps-do-painel',
  // `documentos` é a aba de documentos das fichas; no Lumos, `documents` é a
  // base de conhecimento do assistente.
  documents: 'base-de-conhecimento',
  edit: 'editar',
  faqs: 'perguntas-frequentes',
  finish: 'concluir',
  general: 'geral',
  guardrails: 'limites',
  guidelines: 'diretrizes',
  hours: 'horarios',
  inboxes: 'caixas',
  inboxes_overview: 'visao-das-caixas',
  index: 'inicio',
  integrations: 'integracoes',
  label: 'etiqueta',
  labels: 'etiquetas',
  labels_overview: 'visao-das-etiquetas',
  'lead-score': 'pontuacao-de-leads',
  list: 'lista',
  live_chat: 'chat-ao-vivo',
  locales: 'idiomas',
  media: 'midia',
  'menu-apps': 'apps-do-menu',
  new: 'novo',
  notifications: 'notificacoes',
  office: 'escritorio',
  one_off: 'avulsas',
  ongoing: 'continuas',
  overview: 'visao-geral',
  partners: 'parceiros',
  pending: 'pendentes',
  playground: 'teste',
  professionals: 'profissionais',
  reminders: 'lembretes',
  reports: 'relatorio',
  rescheduling: 'reagendamentos',
  scenarios: 'cenarios',
  security: 'seguranca',
  segments: 'segmentos',
  sequences: 'sequencias',
  services: 'servicos',
  settings: 'ajustes',
  teams: 'times',
  teams_overview: 'visao-dos-times',
  templates: 'modelos-de-mensagem',
  tools: 'ferramentas',
  'whatsapp-templates': 'modelos-whatsapp',
  wizard: 'criacao-guiada',
};

// O primeiro pedaço de cada endereço externo — o Rails serve o app para eles.
export const EXTERNOS = [
  ...new Set(REGRAS.map(regra => regra.externo.split('/')[0])),
].sort();
